const wwfThemeConfig = {
  cookieBotId: "b66ede31-4817-4c2b-a4dd-e671cc93f4e0",
  title: "WWF Community",
  tagline: "Together Possible",
  login: "Login to the pod",
  showLogo: false,
  communityName: "The Pod",
  communityIcon: "/themes/wwf/avatars/avatar-moderator.jpg",
  terms: "/pages/terms-conditions",
  privacy: "/pages/privacy-policy",
  enableDashboardStats: true,
  showUserSettingsPayment: true,
  contactEmail: "wwf@whycatcher.com",
  rewardMessage: "We offer regular rewards for participating in The Pod. You can choose to receive rewards via PayPal or pass back to WWF.",
  slug: "wwf",
  hasBackgrounds: true,
  participantMenu: [
    {
      title: "Settings",
      url: "theme-participant-user-settings",
      icon: "fa-cog",
    },
    {
      title: "Wallpapers",
      url: "participant-wallpapers",
      icon: "fa-download",
    },
  ],
  sideMenu: {
    dashboardEnabled: true,
    dashboardName: "Dashboard",
    aboutEnabled: true,
    FAQEnabled: true,
    newsEnabled: false,
    contactEnabled: true
  },
  images: {
    backgrounds: {
      spring: [
        {
          url: "/themes/wwf/images/spring/1.jpg",
          credit: "Andy Isaacson / WWF-US",
        },
        {
          url: "/themes/wwf/images/spring/2.jpg",
          credit: "Johnson Barros / WWF-Brazil",
        },
        {
          url: "/themes/wwf/images/spring/3.jpg",
          credit: "Richard Barrett / WWF-UK",
        },
        {
          url: "/themes/wwf/images/spring/4.jpg",
          credit: "Nature Picture Library / Klein & Hubert / WWF",
        },
      ],
      summer: [
        {
          url: "/themes/wwf/images/summer/1.jpg",
          credit: "Cat Holloway / WWF",
        },
        {
          url: "/themes/wwf/images/summer/2.jpg",
          credit: "Shutterstock / DES82 / WWF",
        },
        { url: "/themes/wwf/images/summer/3.jpg",
          credit: "Michael Nowak" },
        {
          url: "/themes/wwf/images/summer/4.jpg",
          credit: "Nature Picture Library / Edwin Giesbers / WWF",
        },
      ],
      autumn: [
        {
          url: "/themes/wwf/images/autumn/1.jpg",
          credit: "Nature Picture Library / Chris & Monique Fallows / WWF",
        },
        {
          url: "/themes/wwf/images/autumn/2.jpg",
          credit: "Luca Scudiero / WWF-Italy",
        },
        {
          url: "/themes/wwf/images/autumn/3.jpg",
          credit: "Nature Picture Library / Danny Green / WWF",
        },
        {
          url: "/themes/wwf/images/autumn/4.jpg",
          credit: "Shutterstock / Anuradha Marwah / WWF-Sweden",
        },
      ],
      winter: [
        {
          url: "/themes/wwf/images/winter/1.jpg",
          credit: "Gene Cornelius / Silverback / Netflix",
        },
        {
          url: "/themes/wwf/images/winter/2.jpg",
          credit: "National Geographic Creative / Paul Nicklen / WWF",
        },
        {
          url: "/themes/wwf/images/winter/3.jpg",
          credit:
            "National Geographic Creative / Robert Harding Picture Library / WWF",
        },
        {
          url: "/themes/wwf/images/winter/4.jpg",
          credit: "Xi Zhinong / WildChinaFilm",
        },
      ],
    },
    aboutImage: [
      {
        url: "/themes/wwf/pages/hero/about.jpg",
        credit: "© Teo Lucas  / Gigante Azul / WWF",
      },
    ],
  },
  social: {
    twitter: {
      url: "https://twitter.com/wwf_uk?ref_src=twsrc%5Etfw",
      theme: "light",
    }
  },
  headerLogo: '/images/themes/wwf/wwf-inline-stack.svg',
  tinyMce: {
    content_style: "body { color: #000000; font-size: 14px; font-family: Arial; }"
  },
  dailyCall: {
    style: {
      accent: "#000000", // Main theme color. Used for primary actions and keyboard focus.
      accentText: '#ffffff', // Text color rendered on accent.
      background: '#fbfbfb', // Background color.
    },
  },
};

export default wwfThemeConfig;
